import flatpickr from "flatpickr";
import { getAll, get } from "@/utilities/querySelector";

const initializeDatePicker = () => {
    getAll('nu-dropdown[data-type="date-picker"]').forEach(dropdown => {
        if (dropdown.hasAttribute('data-flatpickr-initialized')) return;

        const button = get('.dropdown-button', dropdown);
        const valueSpan = get('.dropdown-value', dropdown);
        const dateInput = get('input[type="hidden"]', dropdown);
        const dropdownElement = get('.dropdown', dropdown);
        const displayInput = get('input.date-display', dropdown);

        if (!button || !valueSpan || !dateInput) return;

        const defaultValue = dateInput.value || '';
        let displayText = 'Select Date';

        if (defaultValue) {
            try {
                const date = new Date(defaultValue);
                displayText = date.toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric'
                });
            } catch (e) {
                console.error('Error formatting date:', e);
            }
        }

        if (displayInput && defaultValue) {
            displayInput.value = displayText;
        }

        const picker = flatpickr(button, {
            mode: 'single',
            dateFormat: 'Ymd',
            minDate: 'today',
            maxDate: new Date().fp_incr(365),
            nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="11.414" height="7.121" viewBox="0 0 11.414 7.121"><path id="Path_7" data-name="Path_7" d="M-16361.465,9642l5,5,5-5" transform="translate(16362.172 -9641.293)" fill="none" stroke="currentColor" stroke-width="2"/></svg>',
            prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="11.414" height="7.121" viewBox="0 0 11.414 7.121"><path id="Path_7" data-name="Path_7" d="M-16361.465,9642l5,5,5-5" transform="translate(16362.172 -9641.293)" fill="none" stroke="currentColor" stroke-width="2"/></svg>',
            defaultDate: defaultValue || null,
            clickOpens: false,
            static: true,
            appendTo: dropdown,
            onChange: function(selectedDates) {
                if (selectedDates.length === 1) {
                    const selectedDate = selectedDates[0];
                    const formattedDate = flatpickr.formatDate(selectedDate, 'j M Y');
                    const valueDate = flatpickr.formatDate(selectedDate, 'Ymd');

                    dateInput.value = valueDate;
                    valueSpan.textContent = formattedDate;

                    if (displayInput) {
                        displayInput.value = formattedDate;
                    }

                    this.close();
                    dropdownElement.classList.remove('show');
                }
            },
            onReady: function(selectedDates, dateStr, instance) {
                dropdown._fpInstance = instance;

                if (instance.calendarContainer) {
                    instance.calendarContainer.style.position = 'absolute';
                    instance.calendarContainer.style.zIndex = '99999';
                }
            },
            onOpen: function(selectedDates, dateStr, instance) {
                if (event) event.stopPropagation();

                setTimeout(() => {
                    const calendarContainer = instance.calendarContainer;
                    if (!calendarContainer) return;

                    calendarContainer.style.position = 'absolute';

                    const calendarHeight = calendarContainer.offsetHeight;
                    const buttonHeight = button.offsetHeight;
                    const viewportHeight = window.innerHeight;
                    const buttonRect = button.getBoundingClientRect();
                    const spaceBelow = viewportHeight - buttonRect.bottom;

                    if (spaceBelow < calendarHeight) {
                        calendarContainer.style.top = `-${calendarHeight}px`;
                    } else {
                        calendarContainer.style.top = `${buttonHeight + 5}px`;
                    }

                    calendarContainer.style.left = '0';
                }, 0);
            },
            onClose: () => {
                dropdown.removeAttribute('data-calendar-open');
            }
        });

        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (dropdown.hasAttribute('data-calendar-open')) {
                picker.close();
            } else {
                picker.open();
                dropdown.setAttribute('data-calendar-open', 'true');
            }
        });

        dropdown.setAttribute('data-flatpickr-initialized', 'true');
    });
};

document.addEventListener('DOMContentLoaded', initializeDatePicker);
document.addEventListener('htmx:afterSettle', initializeDatePicker);
